<div class="program-terms tw-flex tw-flex-col tw-w-full" data-cy="program-terms-dialog">

  <!-- Header — mirrors the shared alert dialog ribbon -->
  <div
    class="
      modal-header
      tw-flex
      tw-items-center
      tw-justify-between
      tw-bg-[#1B478A]
      tw-text-[#FFFFFF]
      tw-rounded-t-[12px]
      tw-px-[16px]
      tw-py-[14px]
      tw-gap-[10px]
    "
  >
    <p class="modal-title tw-text-[18px] tw-font-bold tw-mb-0 tw-uppercase">
      {{ 'program.shop.terms.conditions' | translate: 'Data Product Terms and Conditions' }}
    </p>

    <button
      type="button"
      mat-icon-button
      (click)="close()"
      class="close-icon !tw-text-white"
      attr.aria-label="{{ 'generic.close' | translate: 'Close' }}"
      data-cy="program-terms-close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div
    class="modal-body tw-bg-white tw-px-[20px] tw-py-[18px]"
    [innerHTML]="content"
    data-cy="program-terms-content"
  ></div>

</div>
